var React = require('react');

function CancelSearch (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"11","fill":"#f1f1f1","key":0}),React.createElement("g",{"transform":"translate(7.242 7.348)","key":1},[React.createElement("line",{"y2":"10.331","transform":"translate(7.305) rotate(45)","fill":"none","stroke":"#000","strokeWidth":"1.5","key":0}),React.createElement("line",{"y2":"10.331","transform":"translate(7.305 7.306) rotate(135)","fill":"none","stroke":"#000","strokeWidth":"1.5","key":1})])]);
}

CancelSearch.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = CancelSearch;

CancelSearch.default = CancelSearch;
